<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Podgląd reklamacji' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>

    <div class="dialog-body">
        <icc-complaint-summary
            [document]="data.document"
            [preview]="true"
        ></icc-complaint-summary>
        <div class="product-elements">
            <ng-container *ngFor="let position of data.positions; index as id;">
                <icc-complaint-position
                    [position]="position"
                    [showDetails]="true"
                    [positionTitle]="positionsTitles.get(position.uuid)"
                    [attachments]="data.attachments"
                    [document]="data.document"
                    [id]="position.uuid"
                    [index]="id"
                    [preview]="true"
                ></icc-complaint-position>
            </ng-container>
        </div>
        <div>
            <ng-container *ngFor="let consent of data.document.consents; let i = index">
                <div class="complaint-form__checkbox">
                    <icc-checkbox
                        [name]="'consent' + consent.id"
                        [ngModel]="consent.checked"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="true"
                    >
                        <span class="complaint-form__consent" [style.fontWeight]="(consent.required) ? 'bold' : 'normal'" [innerHTML]="consent.shortDescription"></span>
                    </icc-checkbox>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>